import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { CertificationHolderListTableFilterSchema } from '../../../../-components/CertificationHolderList/-zod-schema';
export const Route = createFileRoute('/_staff/certification/handling-certification/$id/_layout/certification-holders/')({
  validateSearch: zodValidator(CertificationHolderListTableFilterSchema)
});